import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["word", "answer", "result", "qualityButtons", "nextButton"]

  connect() {
    // Hide the word initially
    if (this.hasWordTarget) {
      this.wordTarget.classList.add("blur-text")
    }
  }

  revealWord() {
    if (this.hasWordTarget) {
      this.wordTarget.classList.remove("blur-text")
    }
  }

  checkAnswer(event) {
    // Only check answer when Enter key is pressed or when the button is clicked
    if (event.type === 'keyup' && event.key !== 'Enter') return
    
    if (!this.hasAnswerTarget || !this.hasWordTarget || !this.hasResultTarget) return
    
    const userAnswer = this.answerTarget.value.trim().toLowerCase()
    const correctWord = this.wordTarget.textContent.trim().toLowerCase()
    
    if (userAnswer === correctWord) {
      this.resultTarget.textContent = "Correct! 🎉"
      this.resultTarget.classList.remove("text-red-500")
      this.resultTarget.classList.add("text-green-500")
      
      // Show quality buttons for correct answer
      if (this.hasQualityButtonsTarget) {
        this.qualityButtonsTarget.classList.remove("hidden")
      }
    } else {
      this.resultTarget.textContent = `Incorrect. The correct spelling is "${correctWord}".`
      this.resultTarget.classList.remove("text-green-500")
      this.resultTarget.classList.add("text-red-500")
      
      // Reveal the word
      this.revealWord()
      
      // Show quality buttons for incorrect answer
      if (this.hasQualityButtonsTarget) {
        this.qualityButtonsTarget.classList.remove("hidden")
      }
    }
  }

  playWord(event) {
    const word = event.currentTarget.dataset.word || this.wordTarget.textContent
    
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(word)
      utterance.rate = 0.8 // Slightly slower rate for clarity
      speechSynthesis.speak(utterance)
    } else {
      alert("Sorry, your browser doesn't support text-to-speech!")
    }
  }
} 